module.exports = __webpack_public_path__ + "static/media/IconSex.f9db196f.png";